var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle-fieldtype-wrapper"},[_c('toggle-input',{attrs:{"value":_vm.value,"read-only":_vm.isReadOnly},on:{"input":_vm.update}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }